var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('add-form'),_vm._v(" "),_c('products-table',{attrs:{"consumptions":_vm.consumptions},on:{"remove":_vm.removeConsumption}},[(_vm.showFilters)?_c('filters-bar',{attrs:{"filters":_vm.searchFilters,"agencies":_vm.agencies},on:{"update":_vm.updateFilters}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-444e2fa6","hasScoped":false,"transformToRequire":{"img":["src","data-src","data-src-retina"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/ConsumptionProducts.vue
// module id = 1842
// module chunks = 0